<div class="notification-container">
    <div class="notification-content" matSnackBarLabel 
        [class.notification-info]="data.type == 0"
        [class.notification-warning]="data.type == 1"
        [class.notification-error]="data.type == 3"
        [class.notification-success]="data.type == 2">
        <mat-icon class="notification-icon" [attr.aria-label]="getIconAriaLabel()" [svgIcon]="currentIcon">
        </mat-icon>
        <span class="notification-message">{{ data.message }}</span>
    </div>

    <button mat-button matSnackBarAction color="primary"
        class="notification-close" 
        (click)="close()">
        Inchide
    </button>
</div>

